<script setup lang="ts">
import { useDefaultStore } from "@/store";

const store = useDefaultStore();
const route = useRoute();

defineOptions({
	name: "HomePage",
});

const isScrolled = ref(false);
const isHidden = ref(false);
const lastScrollPosition = ref(0);

onMounted(async () => {
	await store.getPosts({ limit: 7, landing_page: true });
});

onMounted(() => {
	window.addEventListener("scroll", checkScroll);
});
onUnmounted(() => {
	window.removeEventListener("scroll", checkScroll);
});
function checkScroll() {
	isScrolled.value = window.scrollY > 0;
	const currentScrollPosition =
		window.scrollY || document.documentElement.scrollTop;
	if (currentScrollPosition < 0) {
		return;
	}
	isHidden.value = currentScrollPosition > lastScrollPosition.value;
	lastScrollPosition.value = currentScrollPosition;
}
</script>

<template lang="pug">
#home-page
	header-bar-top
	header-bar.header-bar-sticky-wrapper(
		:class="{ hidden: isHidden && !store.isMobileToggled }"
	)
	router-view
	footer-bar
	to-top-button
</template>

<style lang="scss" scoped>
#home-page {
	margin-top: $nav-top-bar-sm;
	padding-top: 60px;
	position: relative;

	.banner-section {
		flex: 1;
	}

	.header-bar-sticky-wrapper {
		position: fixed;
		top: $nav-top-bar-sm;
		left: 0;
		right: 0;
		z-index: 11;
		transform: translate3d(0, 0, 0);
		transition: transform 0.3s ease-in-out;

		&.hidden {
			transform: translate3d(0, -100%, 0);
		}
	}
}

@media screen and (width >= 768px) {
	#home-page {
		margin-top: $nav-top-bar;
		padding-top: $nav-bottom-bar;

		.header-bar-sticky-wrapper {
			top: $nav-top-bar;
		}
	}
}
</style>
